import { inject, Injectable } from '@angular/core';
import { HierarchicalItem } from '@web-app/app/interfaces/api/hierarchical';
import {
  FeatureDetails,
  FeaturesApi,
  FeatureType,
  TenantDetails,
  TenantDto,
  TenantEdit,
  TenantsApi as TenantsClient,
} from '@web-app/app/services/typed-api';
import { Hierarchical } from '@web-app/app/utils/hierarchical';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TenantsApi {
  private readonly tenantsApi = inject(TenantsClient);
  private readonly featuresApi = inject(FeaturesApi);

  /** The tenants available to the user, sorted parent-first with their hierarchy level. */
  public getTenantByHeader(): Observable<HierarchicalItem<TenantDto>[]> {
    return this.tenantsApi.getTenantsByHeader().pipe(map(tenants => Hierarchical.sortByLevel(tenants ?? [])));
  }

  public getAllFeatures(type: FeatureType = FeatureType.Tenant): Observable<FeatureDetails[]> {
    return this.featuresApi.getFeatures({ type: type.toString() });
  }

  public createTenant(tenant: TenantEdit): Observable<TenantDetails> {
    return this.tenantsApi.createTenant(tenant);
  }

  public editTenant(tenant: TenantEdit): Observable<void> {
    return this.tenantsApi.editTenant(tenant.id!, tenant);
  }

  public removeTenant(tenantId: number): Observable<void> {
    return this.tenantsApi.deleteTenant(tenantId);
  }
}
